import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center py-12 md:py-16 lg:py-20 px-4">
      <div className="flex items-center justify-center w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 bg-primary/10 rounded-full mb-5 md:mb-6 lg:mb-8">
        <Icon 
          name="MessageSquare" 
          size={40} 
          color="var(--color-primary)" 
          strokeWidth={2}
          className="md:w-12 md:h-12 lg:w-14 lg:h-14"
        />
      </div>
      
      <h3 className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground mb-3 md:mb-4 text-center">
        No Stories Yet
      </h3>
      
      <p className="text-sm md:text-base lg:text-lg text-muted-foreground text-center max-w-md mb-6 md:mb-8 lg:mb-10">
        Be the first to share your emotional journey. Your story matters and can help others feel less alone.
      </p>
      
      <Button
        variant="default"
        size="lg"
        iconName="Plus"
        iconPosition="left"
        onClick={() => navigate('/create-post')}
        className="min-h-[44px]"
      >
        Share Your Story
      </Button>
    </div>
  );
};

export default EmptyState;